// extracted by mini-css-extract-plugin
module.exports = {"feed":"styles_feed__4LTc2","list":"styles_list__bcbAX"};